/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MdsEventsResponse } from '../model/mdsEventsResponse';
import { MdsStopsResponse } from '../model/mdsStopsResponse';
import { MdsStopsSingleResponse } from '../model/mdsStopsSingleResponse';
import { MdsTelemetryResponse } from '../model/mdsTelemetryResponse';
import { MdsTripsResponse } from '../model/mdsTripsResponse';
import { MdsVehicleStatusResponse } from '../model/mdsVehicleStatusResponse';
import { MdsVehicleStatusSingleResponse } from '../model/mdsVehicleStatusSingleResponse';
import { MdsVehiclesResponse } from '../model/mdsVehiclesResponse';
import { MdsVehiclesSingleResponse } from '../model/mdsVehiclesSingleResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MdsApiService {

    protected basePath = 'https://app-tst.pikyrent.com:33443';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get historical MDS events by hour
     * 
     * @param event_time Timestamp used as start of the hour window.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsHistoricalEvents(event_time: string, observe?: 'body', reportProgress?: boolean): Observable<MdsEventsResponse>;
    public getMdsHistoricalEvents(event_time: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MdsEventsResponse>>;
    public getMdsHistoricalEvents(event_time: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MdsEventsResponse>>;
    public getMdsHistoricalEvents(event_time: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (event_time === null || event_time === undefined) {
            throw new Error('Required parameter event_time was null or undefined when calling getMdsHistoricalEvents.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (event_time !== undefined && event_time !== null) {
            queryParameters = queryParameters.set('event_time', <any>event_time);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MdsEventsResponse>('get',`${this.basePath}/mds/events/historical`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get recent MDS events in a range
     * 
     * @param start_time 
     * @param end_time 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsRecentEvents(start_time: string, end_time: string, observe?: 'body', reportProgress?: boolean): Observable<MdsEventsResponse>;
    public getMdsRecentEvents(start_time: string, end_time: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MdsEventsResponse>>;
    public getMdsRecentEvents(start_time: string, end_time: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MdsEventsResponse>>;
    public getMdsRecentEvents(start_time: string, end_time: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (start_time === null || start_time === undefined) {
            throw new Error('Required parameter start_time was null or undefined when calling getMdsRecentEvents.');
        }

        if (end_time === null || end_time === undefined) {
            throw new Error('Required parameter end_time was null or undefined when calling getMdsRecentEvents.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (start_time !== undefined && start_time !== null) {
            queryParameters = queryParameters.set('start_time', <any>start_time);
        }
        if (end_time !== undefined && end_time !== null) {
            queryParameters = queryParameters.set('end_time', <any>end_time);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MdsEventsResponse>('get',`${this.basePath}/mds/events/recent`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get monthly MDS report
     * 
     * @param filename 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsReport(filename: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getMdsReport(filename: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getMdsReport(filename: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getMdsReport(filename: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (filename === null || filename === undefined) {
            throw new Error('Required parameter filename was null or undefined when calling getMdsReport.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/vnd.mds+csv'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<string>('get',`${this.basePath}/mds/reports/${encodeURIComponent(String(filename))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get one MDS stop by UUID
     * 
     * @param stop_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsStopById(stop_id: string, observe?: 'body', reportProgress?: boolean): Observable<MdsStopsSingleResponse>;
    public getMdsStopById(stop_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MdsStopsSingleResponse>>;
    public getMdsStopById(stop_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MdsStopsSingleResponse>>;
    public getMdsStopById(stop_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (stop_id === null || stop_id === undefined) {
            throw new Error('Required parameter stop_id was null or undefined when calling getMdsStopById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MdsStopsSingleResponse>('get',`${this.basePath}/mds/stops/${encodeURIComponent(String(stop_id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get MDS stops
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsStops(observe?: 'body', reportProgress?: boolean): Observable<MdsStopsResponse>;
    public getMdsStops(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MdsStopsResponse>>;
    public getMdsStops(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MdsStopsResponse>>;
    public getMdsStops(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MdsStopsResponse>('get',`${this.basePath}/mds/stops`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get MDS telemetry by hour
     * 
     * @param telemetry_time Timestamp used as start of the hour window.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsTelemetry(telemetry_time: string, observe?: 'body', reportProgress?: boolean): Observable<MdsTelemetryResponse>;
    public getMdsTelemetry(telemetry_time: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MdsTelemetryResponse>>;
    public getMdsTelemetry(telemetry_time: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MdsTelemetryResponse>>;
    public getMdsTelemetry(telemetry_time: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (telemetry_time === null || telemetry_time === undefined) {
            throw new Error('Required parameter telemetry_time was null or undefined when calling getMdsTelemetry.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (telemetry_time !== undefined && telemetry_time !== null) {
            queryParameters = queryParameters.set('telemetry_time', <any>telemetry_time);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MdsTelemetryResponse>('get',`${this.basePath}/mds/telemetry`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get MDS trips by end hour
     * 
     * @param end_time Timestamp used as start of the hour window.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsTrips(end_time: string, observe?: 'body', reportProgress?: boolean): Observable<MdsTripsResponse>;
    public getMdsTrips(end_time: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MdsTripsResponse>>;
    public getMdsTrips(end_time: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MdsTripsResponse>>;
    public getMdsTrips(end_time: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (end_time === null || end_time === undefined) {
            throw new Error('Required parameter end_time was null or undefined when calling getMdsTrips.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (end_time !== undefined && end_time !== null) {
            queryParameters = queryParameters.set('end_time', <any>end_time);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MdsTripsResponse>('get',`${this.basePath}/mds/trips`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get one MDS vehicle by device UUID
     * 
     * @param device_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsVehicleById(device_id: string, observe?: 'body', reportProgress?: boolean): Observable<MdsVehiclesSingleResponse>;
    public getMdsVehicleById(device_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MdsVehiclesSingleResponse>>;
    public getMdsVehicleById(device_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MdsVehiclesSingleResponse>>;
    public getMdsVehicleById(device_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (device_id === null || device_id === undefined) {
            throw new Error('Required parameter device_id was null or undefined when calling getMdsVehicleById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MdsVehiclesSingleResponse>('get',`${this.basePath}/mds/vehicles/${encodeURIComponent(String(device_id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get MDS vehicles status
     * 
     * @param page 
     * @param limit 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsVehicleStatus(page?: number, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<MdsVehicleStatusResponse>;
    public getMdsVehicleStatus(page?: number, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MdsVehicleStatusResponse>>;
    public getMdsVehicleStatus(page?: number, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MdsVehicleStatusResponse>>;
    public getMdsVehicleStatus(page?: number, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MdsVehicleStatusResponse>('get',`${this.basePath}/mds/vehicles/status`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get one MDS vehicle status by device UUID
     * 
     * @param device_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsVehicleStatusById(device_id: string, observe?: 'body', reportProgress?: boolean): Observable<MdsVehicleStatusSingleResponse>;
    public getMdsVehicleStatusById(device_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MdsVehicleStatusSingleResponse>>;
    public getMdsVehicleStatusById(device_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MdsVehicleStatusSingleResponse>>;
    public getMdsVehicleStatusById(device_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (device_id === null || device_id === undefined) {
            throw new Error('Required parameter device_id was null or undefined when calling getMdsVehicleStatusById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MdsVehicleStatusSingleResponse>('get',`${this.basePath}/mds/vehicles/status/${encodeURIComponent(String(device_id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get MDS vehicles
     * 
     * @param page 
     * @param limit 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getMdsVehicles(page?: number, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<MdsVehiclesResponse>;
    public getMdsVehicles(page?: number, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MdsVehiclesResponse>>;
    public getMdsVehicles(page?: number, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MdsVehiclesResponse>>;
    public getMdsVehicles(page?: number, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<MdsVehiclesResponse>('get',`${this.basePath}/mds/vehicles`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
